import generalUpload from "../_section/upload.class";
export class userCreditStatementUpload extends generalUpload {
    constructor(request, upload, queries) {
        super(request, upload, queries);
    }
}
const template= {
    items: [
        {
            name: 'accountNumber',
            label: 'Account Number',
            type: 'text',
            mutate: 'iban'
        }, {
            name: 'documentDate',
            label: 'Document Date',
            type: 'date',
        },{
            name: 'startDate',
            label: 'Start Date',
            type: 'date',
        }, {
            name: 'outstandingBalance',
            label: 'Outstanding',
            type: 'currency',
        }, {
            name: 'creditLimit',
            label: 'Credit Limit',
            type: 'currency',
        }
    ]
}
export class adminCreditStatementUpload extends userCreditStatementUpload {

    constructor(request, upload, queries) {
        super(request, upload, queries);

        this.calcValues(template)
        if (this.values.documentDate) {
            this.setDateData({
                dated: this.values.documentDate,
                range: {
                    from: { date: this.values?.startDate ?? this.values.documentDate.subtract(1, 'month') },
                    to: { date: this.values.documentDate },
                },
                expires: this.values.documentDate.add(6, 'month'),
            })
        }
    }
    calcProblems(parentSection){
        if (this.values.accountNumber && this.values.accountNumber.replace(/[^a-zA-Z0-9]/g, '') !== parentSection.data?.accountNumber?.replace(/[^a-zA-Z0-9]/g, '')) {
            this.problems.push(`Account number mismatch`)
        }
    }

}
